<template>
  <h3 class="container">ページがありません。戻るボタンで戻って下さい。</h3>
</template>
<style lang="scss" scoped>
.container {
  display: flex;
  height: 100vh !important;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
}
</style>
